import gql from 'graphql-tag'

export default gql`
  fragment DraftPostTaggedChildrenWithInfo on DraftPost {
    children {
      fkey
      fullName
      image
      otherDetails {
        consents
      }
    }
  }
`
